import React, { useState } from "react";
import Button from "../../components/Button/Button";
import DownloadIcon from "@mui/icons-material/Download";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";

const DownloadPdfButton = () => {
  const [loading, setLoading] = useState(false);

  const handleDownload = async () => {
    setLoading(true);
    try {
      const element = document.getElementById('reporting-root');
      if (!element) {
        console.error("Element not found!");
        setLoading(false);
        return;
      }

      // Capture the canvas
      const canvas = await html2canvas(element, {
        scale: 2,
        useCORS: true,
      });

      // Convert the canvas to an image
      const imgData = canvas.toDataURL("image/png");

      // Create a PDF and add the image to it
      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: "a4",
      });

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();

      // Calculate the number of pages needed
      const canvasWidth = canvas.width;
      const canvasHeight = canvas.height;
      const pageHeight = (canvasWidth / pdfWidth) * pdfHeight;
      let position = 0;

      while (position < canvasHeight) {
        const canvasPage = document.createElement("canvas");
        canvasPage.width = canvasWidth;
        canvasPage.height = Math.min(pageHeight, canvasHeight - position);

        const ctx = canvasPage.getContext("2d");
        ctx.drawImage(canvas, 0, position, canvasWidth, canvasPage.height, 0, 0, canvasWidth, canvasPage.height);

        const pageData = canvasPage.toDataURL("image/png");
        if (position > 0) {
          pdf.addPage();
        }

        pdf.addImage(pageData, "PNG", 0, 0, pdfWidth, (canvasPage.height / canvasWidth) * pdfWidth);
        position += pageHeight;
      }
      pdf.save("Report.pdf");
    } catch (error) {
      console.error("Error generating PDF: ", error);
    } finally {
      setLoading(false);
    }
  };

  return (
        <Button
            sx={{ height: "32px", pr: '3px', fontWeight: 600, marginLeft: 'auto', borderRadius: '6px', }}
            variant="textOnly"
            label={loading ? "Generating pdf..." : "Download report"}
            onClick={handleDownload}
            icon="download"
            disabled={loading}
        />
    )
};

export default DownloadPdfButton;
